import React from "react";

class AppStore extends React.Component {
  componentDidMount() {
    window.location = "https://conxtd.com/apps";
  }
  render() {
    return null;
  }
}
export default AppStore;
